import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import SectionImageBlock from './styles/SectionImageBlock';
import TextBlock from './styles/TextBlock';
import SectionTitle from './styles/SectionTitle';
import SectionParagraph from './styles/SectionParagraph';
import SectionParagraphContainer from './styles/SectionParagraphContainer';
import SectionRoot from './styles/SectionRoot';

function TargetAudienceSection({ index }) {
  const { formatMessage } = useIntl();
  return (
    <SectionRoot
      minHeight="0px"
    >
      <TextBlock>
        <SectionTitle
          variant="title"
          intlKey={`cms.businessAccountPage.cardsArea[${index}].title`}
          color="black"
          colorVariant="default"
        />
        <SectionParagraphContainer>
          <SectionParagraph
            variant="subtitle"
            color="black"
            colorVariant="default"
            intlKey={`cms.businessAccountPage.cardsArea[${index}].description`}
            whiteSpace="pre-line"
          />
        </SectionParagraphContainer>
      </TextBlock>
      <SectionImageBlock
        backgroundImage="pj-phone-and-business-card/pj-phone-and-business-card.jpg"
        alt={formatMessage({ id: 'BUSINESS_ACCOUNT.TARGET_AUDIENCE.IMAGE_ALT' })}
        imageWidth="100%"
        imageHeight="100%"
        loading="lazy"
      />
    </SectionRoot>
  );
}

TargetAudienceSection.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(TargetAudienceSection);
